import paths from "@icarius-router/paths";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.calculationsFunctions],
        config: {
            headerName: getLocalizedString("functionNameLongAlt"),
            field: "name",
            filter: "agSetColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [paths.calculationsFunctions],
        config: {
            headerName: getLocalizedString("jobDescription"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.calculationsFunctions],
        config: {
            headerName: getLocalizedString("application"),
            field: "type",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.calculationsFunctions],
        config: {
            headerName: getLocalizedString("calculationSequence"),
            field: "sequence",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.calculationsFunctions],
        config: {
            field: "Fórmula",
            headerName: getLocalizedString("formula"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            headerName: getLocalizedString("employeesProcessCodigoConcepto"),
            field: "Código de concepto",
            filter: "agSetColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: "Nombre del concepto",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            headerName: getLocalizedString("positionEditorId"),
            field: "ID",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Secuencia de cálculo",
            headerName: getLocalizedString("calculationSequence"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            cellClass: "currencyValueNoDecimal",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            headerName: getLocalizedString("pollFamily"),
            field: "Familia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Fórmula",
            headerName: getLocalizedString("formula"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            headerName: getLocalizedString("clasification"),
            field: "Clasificación",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 01",
            headerName: getLocalizedString("group01"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 02",
            headerName: getLocalizedString("group02"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 03",
            headerName: getLocalizedString("group03"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 04",
            headerName: getLocalizedString("group04"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 05",
            headerName: getLocalizedString("group05"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 06",
            headerName: getLocalizedString("group06"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 07",
            headerName: getLocalizedString("group07"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 08",
            headerName: getLocalizedString("group08"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 09",
            headerName: getLocalizedString("group09"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 10",
            headerName: getLocalizedString("group10"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 11",
            headerName: getLocalizedString("group11"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Grupo 12",
            headerName: getLocalizedString("group12"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            headerName: getLocalizedString("filterAcumuladores"),
            field: "Acumuladores",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            field: "Nóminas",
            headerName: getLocalizedString("payrolls"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.conceptsAndFormulas],
        config: {
            headerName: getLocalizedString("availability"),
            field: "Disponibilidad",
            filter: "agSetColumnFilter",
        }
    },
]